RivalIQ.apps.Dashboard.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    App.views.DetailsLayout = RivalIQ.views.LayoutView.mixin({
        template: '#dashboardWidgetDetailLayoutTemplate',

        panelView: App.views.DetailsPanel,

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        regions: {
            body: '.x-widget-container',
            actions: {
                selector: '.x-toolbar-actions-region',
                regionClass: RivalIQ.regions.ListRegion
            },
            leftActions: {
                selector: '.x-left-toolbar-actions-region',
                regionClass: RivalIQ.regions.ListRegion
            }
        },

        onBeforeShow: function () {
            const me = this;

            me.showLeftToolbarActions();
            me.showToolbarActions();

            const View = me.getBodyView();
            me.body.show(new View({
                dashboardModel: me.dashboardModel
            }));
        },

        getBodyView: function () {
            const me = this;
            return (me.dashboardModel.getDetailPanelView() || me.panelView);
        },

        showLeftToolbarActions: function () {
            const me = this;
            me.showBackLink();
        },

        showBackLink: function () {
            const me = this;

            const name = me.dashboardModel.getBackLinkName();
            const linkName = _.compact([
                $.tagHtml('i', {
                    class: ['fa', 'fa-chevron-left']
                }),
                (name ? $.tagHtml('span', {
                    html: name
                }) : null)
            ]).join('');

            const className = me.dashboardModel.getBackLinkClassName();

            me.leftActions.show(new RivalIQ.views.Link({
                className: className,
                linkName: linkName,
                attributes: {
                    href: '#'
                },
                action: function () {
                    RivalIQ.execute('history:navigate', me.dashboardModel.getBackPath(), {
                        trigger: true
                    });
                }
            }), {
                preventDestroy: true
            });

        },

        showToolbarActions: function () {
            const me = this;
            if (RivalIQ.state.user.isReadOnly()) {
                return;
            }
            me.showExportDropdown();
        },

        showExportDropdown: function () {
            const me = this;
            me.actions.show(me.dashboardModel.getExportDropdown(), {
                preventDestroy: true
            });
        }
    });
});
